function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h70v70H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.911 20.258c-.117-.932.509.561 1.877 4.48a22.959 22.959 0 01-.517 16.522c-4.903 11.645-18.267 17.067-29.85 12.11-2.853-1.464-5.02-2.994-6.5-4.591",
  stroke: "#371447",
  strokeWidth: 1.84
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  fillRule: "nonzero",
  d: "M55.993 15.447l-10.807-3.88a1.223 1.223 0 00-1.531.682l-4.35 10.628c-.391.956.589 1.857 1.553 1.428l15.157-6.749c.965-.43.95-1.76-.022-2.11z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.966 28.504)"
}, /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 1.84,
  fill: "#3DB2DC",
  cx: 11.936,
  cy: 11.976,
  rx: 11.936,
  ry: 11.976
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.161 17.085a4.8 4.8 0 01-1.586-.519 4.28 4.28 0 01-1.27-1.038 4.787 4.787 0 01-.84-1.524c-.203-.585-.304-1.243-.304-1.974 0-.706.106-1.364.318-1.975a4.538 4.538 0 01.937-1.596 4.574 4.574 0 011.529-1.087c.606-.272 1.3-.424 2.082-.456l.134-1.524a.692.692 0 01.193-.412.584.584 0 01.452-.19h.874l-.192 2.223c.507.09.965.244 1.375.46.41.217.789.487 1.135.81l-.616.845a.841.841 0 01-.192.204.5.5 0 01-.288.068.694.694 0 01-.28-.063 5.73 5.73 0 01-.33-.16 5.829 5.829 0 00-.42-.194 3.789 3.789 0 00-.538-.175l-.557 6.53c.34-.032.623-.095.85-.189.228-.093.424-.189.587-.286.164-.097.306-.184.428-.262a.69.69 0 01.375-.116.52.52 0 01.442.203l.654.854a3.86 3.86 0 01-.74.68c-.27.187-.552.344-.846.47a4.95 4.95 0 01-.923.291 7.54 7.54 0 01-.981.141l-.116 1.427a.7.7 0 01-.192.422.584.584 0 01-.452.189h-.875l.173-2.077zM9.507 12.03c0 .866.158 1.567.472 2.1a2.35 2.35 0 001.346 1.082l.548-6.472c-.808.103-1.404.44-1.789 1.01-.384.568-.577 1.329-.577 2.28z",
  fill: "#371447"
})));

function SvgRoundUpsLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRoundUpsLg;